import React from 'react';
import {
  DetailActionButton,
  PrimaryDetailActionbarButton,
  SecondaryDetailActionbarButton,
} from '@eas/common-web';
import { useCancelDialog } from './dialog-actions/cancel-hook';
import { useStartDialog } from './dialog-actions/start-hook';
import { useActivateDialog } from './dialog-actions/activate-hook';
import { useDeactivateDialog } from './dialog-actions/deactivate-hook';

export function JobsActionbar() {
  const { callApi: startApiCall, showStartButton } = useStartDialog();
  const { callApi: cancelApiCall, showCancelButton } = useCancelDialog();
  const { callApi: activateApiCall, showButton: showActivateButton } =
    useActivateDialog();
  const { callApi: deactivateApiCall, showButton: showDeactivateButton } =
    useDeactivateDialog();

  return (
    <>
      {showStartButton && (
        <DetailActionButton
          promptKey="START"
          buttonLabel="Spustit"
          dialogText="Skutečně chcete spustit úlohu?"
          dialogTitle="Varování"
          apiCall={startApiCall}
          ButtonComponent={PrimaryDetailActionbarButton}
        />
      )}
      {showCancelButton && (
        <DetailActionButton
          promptKey="Zastavit"
          buttonLabel="Zastavit"
          dialogTitle="Varování"
          dialogText="Zastavení běžící úlohy může spůsobit inkonzistenci dat. Skutečně chcete zastavit běžící úlohu?"
          apiCall={cancelApiCall}
          ButtonComponent={SecondaryDetailActionbarButton}
        />
      )}

      {showActivateButton && (
        <PrimaryDetailActionbarButton
          label="aktivovat"
          onClick={activateApiCall}
        />
      )}
      {showDeactivateButton && (
        <SecondaryDetailActionbarButton
          label="Zneplatnit"
          onClick={deactivateApiCall}
        />
      )}
    </>
  );
}
